<script setup lang="ts"></script>

<template>
  <div class="main-blank-container">
    <slot></slot>
  </div>
  <!-- ToastGroup -->
</template>

<style lang="scss" scoped></style>
